import {
  documentGetFullscreenElement,
  exitFullScreen,
  fullScreen,
  removeFullScreenEventListeners,
} from '@/js/utils/util'

const CONTROLLER_DEACTIVATE_TIME = 3000

type TimeoutId = ReturnType<typeof setTimeout>

export function scheduleControllerHide(hideController: () => void): TimeoutId {
  return setTimeout(hideController, CONTROLLER_DEACTIVATE_TIME)
}

export function cancelControllerHide(timeoutId: TimeoutId | null): void {
  if (timeoutId !== null) {
    clearTimeout(timeoutId)
  }
}

export function toggleFullscreen(
  element: Element,
  fullScreenFlag: boolean,
  onFullscreenChange: EventListenerOrEventListenerObject
): boolean {
  if (fullScreenFlag) {
    exitFullScreen(onFullscreenChange)
  } else {
    fullScreen(element, onFullscreenChange)
  }

  return !fullScreenFlag
}

export function syncFullscreenFlag(fullScreenFlag: boolean): boolean {
  return documentGetFullscreenElement() ? fullScreenFlag : false
}

export function cleanupUiControl(
  controllerTimeoutId: TimeoutId | null,
  onFullscreenChange: EventListenerOrEventListenerObject
): void {
  cancelControllerHide(controllerTimeoutId)
  removeFullScreenEventListeners(onFullscreenChange)
}
